import { GiTreeGrowth, GiTrophyCup } from "react-icons/gi";
import { FaLeaf, FaUsers, FaMedal } from "react-icons/fa";
import { MdVerifiedUser } from "react-icons/md";
import { useGetTrackImpactData } from "../../queries/dashboard";
import Section from "./Section";

const TrackImpactMatrix = () => {

    const { data, isPending } = useGetTrackImpactData();

    const impactData = {
        totalCarbonSavings: data?.totalCarbonSavingsKg || 0,
        totalPointsEarned: data?.totalPointsEarned || 0,
        totalChallengeSubmissions: data?.totalVerifiedSubmissions || 0,
        totalTreesPlanted: data?.totalTreesPlanted || 0,
        totalVolunteers: data?.totalEventVolunteers || 0,
        totalBadgesAssigned: data?.totalBadgesAssigned || 0,
    };

    const ImpactCard = ({ title, value, unit, icon, color = "primary" }) => (
        <div className={`bg-white shadow border border-${color} rounded-lg p-5 flex-1 min-w-[200px] ${color} flex flex-col gap-3 justify-between`}>
            <div className='flex items-center justify-between'>
                <h3 className={`text-base font-extrabold text-${color}`}>{title}</h3>
                {icon && <span className={`text-2xl text-${color}`}>{icon}</span>}
            </div>
            <div className={`text-2xl font-bold text-${color}`}>
                {value}{unit && <span className="text-base ml-1">{unit}</span>}
            </div>
        </div>
    );

    return (
        <Section
            title={"Impact Matrix"}
            isLoading={isPending}
            gridCols={3}
            theme="blue"
        >
            <ImpactCard
                title="Carbon Savings"
                value={impactData.totalCarbonSavings}
                unit="kg"
                icon={<FaLeaf />}
                color="chipBlue"
            />
            <ImpactCard
                title="Points Earned"
                value={impactData.totalPointsEarned}
                icon={<GiTrophyCup />}
                color="chipBlue"
            />
            <ImpactCard
                title="Verified Submissions"
                value={impactData.totalChallengeSubmissions}
                icon={<MdVerifiedUser />}
                color="chipBlue"
            />
            <ImpactCard
                title="Trees Planted"
                value={impactData.totalTreesPlanted}
                icon={<GiTreeGrowth />}
                color="chipBlue"
            />
            <ImpactCard
                title="Volunteers"
                value={impactData.totalVolunteers}
                icon={<FaUsers />}
                color="chipBlue"
            />
            <ImpactCard
                title="Badges Assigned"
                value={impactData.totalBadgesAssigned}
                icon={<FaMedal />}
                color="chipBlue"
            />
        </Section>
    );
};

export default TrackImpactMatrix;